import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import './styles.scss';

import PortalTextbox from '../portal/portalTextBox';
import ToastrLevelsEnum from '../../services/enums/toastrLevelsEnum';
import ToastrService from '../../services/ui/toastrService';
import {Button, Toggle} from '@checkmarx/cx-ui';
import {toInteger} from 'lodash';

@inject('translationsStore', 'adminConfigurationStore')
@observer
export default class UserInactivityCleanup extends Component {

    confStore = this.props.adminConfigurationStore;

    state = {
      toggle: true
    }

    componentDidMount() {
       this.confStore.getUserInactivitySetting();
    }

    toggleSlider() {
        this.setState({toggle: !this.state.toggle});
    }

    submit() {
      if (!this.state.toggle) this.confStore.userInactivity = 0;
      this.confStore.setUserInactivitySetting().then(() => {
          var level = ToastrLevelsEnum.SUCCESS;
          var message = this.props.translationsStore.translate('USER_INACTIVE_SETTINGS_UPDATE_SUCCESS_MESSAGE');
          ToastrService.triggerToastr({ level, message });
      });
    }

    render() {
        return (
            <div className='user-inactivity-container' data-cy='user-incativity-cleanup-form'>
                <div className='general-settings-title'>
                    {this.props.translationsStore.translate('USER_INACTIVE_SETTINGS_TITLE')}
                </div>
                <div className={'setting-sub-title'}>
                    {this.props.translationsStore.translate('USER_INACTIVE_SETTINGS_INFO')}
                </div>
                <PortalTextbox
                    floatingLabelText={this.props.translationsStore.translate('USER_INACTIVE_SETTINGS_DAYS')}
                    onChange={(e) => {
                        const val = toInteger(e.target.value);
                        this.confStore.userInactivity = val;
                    }}
                    value={ this.confStore.userInactivity ? this.confStore.userInactivity : ''}
                    width={200}
                    dataCy={'inactivity-days-field'}
                />
                <Toggle
                    icons={false}
                    onChange={() => {
                        this.toggleSlider();
                    }}
                    disabled={false}
                    checked={this.confStore.userInactivity > 0 && this.state.toggle}
                    text={this.props.translationsStore.translate('USER_INACTIVE_SETTINGS_TOGGLE')}
                    dataCy={'inactivity-toggle'}
                />
                <div className={'btn-user-inactivity-cleanup-wrapper'}>
                    <Button
                        dataCy='btn-user-inactivity-cleanup-submit'
                        onClick={() => {
                            this.submit();
                        }}
                        inProgress={false}
                        text={this.props.translationsStore.translate('SAVE')} >
                    </Button>
                </div>
            </div>
        );
    }
}
